import * as ng from 'angular';

ng.module('e360')
   .factory('geocodeService', geocodeServiceFactory);

export interface GeocodeService {
   (address:string, city:string, state:string):ng.IPromise<number[]>
}

geocodeServiceFactory.$inject = ['$q', '$http', 'session'];
export function geocodeServiceFactory($q:ng.IQService, $http:ng.IHttpService, session):GeocodeService {
   return geocode;

   function geocode(address:string, city:string, state:string) {
      let query = encodeURIComponent([address, city, state].join(','));
      let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${query}&key=${session.googleApiKey()}`;

      return $http.get<any>(url).then((response) => {
         let results = response.data.results;
         if (results.length === 0) {
            return $q.reject();
         } else {
            // this assumes first result is accurate, which could be problematic
            // since API can return many results
            let result = results[0];

            return [
               result.geometry.location.lat,
               result.geometry.location.lng
            ];
         }
      });
   }
}
